<template>
  <!-- https://3.swiper.com.cn/demo/pcSlide/ -->
  <div class="cmp-swiper">
    <div class="cmp-swiper-wrap pc">
      <div wrap class="gallery-wrap">
        <div class="swiper-container gallery-top" ref="myGalleryTop">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in detailData.collectImages" :key="i">
              <!-- <div class="pic_bg" :style="{backgroundImage:'url(' + item.url + ')'}"></div> -->
              <img :src="item.attPath||''" :onerror="$store.state.app.defaultErrorImg" preview="0" preview-text="" alt="">
            </div>
            <!-- 静态数据 勿删 start -->
            <!-- <div class="swiper-slide">
              <div class="pic_bg" style="background: url('/files/museumWeb//static/upload/e7520b36-4e61-40dd-875c-af46732409ec.png');"></div>
              <img src="@images/1.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/2.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/5.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/6.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" preview="0" preview-text="" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" preview="0" preview-text="" alt="">
            </div> -->
            <!-- 静态数据 误删 end -->
          </div>

          <div class="icon-3d-box g-pointer" @click="openDetail" v-if="detailData.threeDimensionalInfo">
            <i class="icon-3d"></i>
          </div>

          <!-- Add Arrows -->
          <!-- <div class="swiper-button-prev swiper-button-white" @click.stop="clickPrev"></div>
          <div class="swiper-button-next swiper-button-white" @click.stop="clickNext"></div> -->
        </div>
      </div>

      <div class="thumbs-wrap">
        <div class="swiper-container gallery-thumbs" ref="myThumb">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, i) in detailData.collectImages" :key="i">
              <div class="pic_bg" :style="{backgroundImage:'url(' + item.url + ')'}"></div>
              <img :src="item.attPath||''" :onerror="$store.state.app.defaultErrorImg" alt="">
            </div>

            <!-- 静态数据 误删 start -->
            <!-- <div class="swiper-slide active">
              <img src="@images/1.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/2.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/5.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/6.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/3.jpg" alt="">
            </div>
            <div class="swiper-slide">
              <img src="@images/4.jpg" alt="">
            </div> -->
            <!-- 静态数据 误删 end -->
          </div>
        </div>
        <!-- Add Arrows -->
        <div class="swiper-button-prev swiper-button-white" @click.stop="clickPrev"></div>
        <div class="swiper-button-next swiper-button-white" @click.stop="clickNext"></div>
      </div>

      <div class="pic-info">
        <div class="g-border">
          <p class="collect-title m-font-1">{{detailData.collectName}}</p>
          <!-- <div class="m-line mt-20 mb-20"></div> -->
          <div class="des-box m-font-2">
            <p><label>年代：</label>{{detailData.collectYear}}</p>
            <p><label>类别：</label>{{detailData.collectType}}</p>
            <p><label>级别：</label>{{detailData.collectLevel}}</p>
            <p><label>质地：</label>{{detailData.collectTexture}}</p>
            <p><label>尺寸：</label>{{detailData.detailSize}}</p>
            <!-- <p>收藏单位：{{detailData.museumName}}</p> -->
          </div>

          <div class="btn-box">
            <!-- <a class="btn-digital g-btn-level-1" @click="handleMax">查看高清大图</a> -->
            <!-- <span class="box-like">
              <i class="icon-like" :class="{'active': isLike}" @click.stop="handleLike"></i>
              {{detailData.loveNum}}人喜欢
            </span> -->

            <!-- <myCmpLike class="like-box light" :isLike="detailData.iscollection?true:false" :likeId="detailData.collectId" :type="`1`" :num="detailData.collectedCounts" :showTxt="true"></myCmpLike> -->
            <!-- <span>人收藏</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Swiper from 'swiper'
  import 'swiper/dist/css/swiper.min.css'
  // import 'swiper/swiper-bundle.css';  // 6以上 部分api有问题 eg:slidesPerColumn无效
  import myCmpLike from '@cmp/my-like'
  export default {
    components: { myCmpLike },
    props: {

    },
    watch: {
      $route() {
        this.activeMenu = '/' + this.$route.path.split('/')[1]
        this.selectedItem = this.menuList.findIndex(item => item.url === this.activeMenu)
      }
    },
    data() {
      return {
        detailData: {},
        galleryTop: '',
        galleryThumbs: '',
        isLike: ''
      }
    },
    methods: {
      init(detailData) {
        this.isLike = localStorage.getItem('tj_like_'+detailData.collectId)
        this.detailData = detailData
        let vm = this
        this.$nextTick(() => {
          this.galleryTop = new Swiper('.gallery-top', {
            observer: true,
            observeParents: true,
            onSlideChangeStart: function() {
              if(vm.detailData.collectImages.length > 1) {
                vm.updateNavPosition()
              }
            }
          })
          this.galleryThumbs = new Swiper('.gallery-thumbs', {
            slidesPerView: 'auto',
            allowTouchMove: false,
            observer: true,
            observeParents: true,
            onInit: function() {
              // 默认第一个加上active
              vm.$refs.myThumb.getElementsByClassName('swiper-slide')[0].classList.add('active')
            },
            onTap: function() {
              vm.galleryTop.slideTo(vm.galleryThumbs.clickedIndex)
            }
          })
  
          this.$previewRefresh()
        })
      },
      openDetail() {
        window.open(this.detailData.threeDimensionalInfo)
      },
      reDraw() {
        // setTimeout(() => {
        //   this.$previewRefresh()
        //   // this.$redrawVueMasonry()
        // }, 0)
      },
      // // 喜欢、点赞
      // handleLike() {
      //   if(this.isLike) return

      //   this.$http
      //     .post('/collect/love', {
      //       id: this.detailData.collectId
      //     })
      //     .then(res => {
      //       if (res.success) {
      //         this.$message.success('点赞成功')
      //         this.isLike = true
      //         localStorage.setItem('tj_like_'+this.detailData.collectId, true)
      //         this.$emit('refresh')
      //       } else {
      //         this.$message.error(res.message)
      //       }
      //     })
      // },
      handleMax() {
        console.log(this.$refs.myGalleryTop.getElementsByClassName('swiper-slide')[0].getElementsByTagName('img')[0])
        if(this.galleryTop) {
          let _index = this.galleryTop.activeIndex
          this.$refs.myGalleryTop.getElementsByClassName('swiper-slide')[_index].getElementsByTagName('img')[0].click()
        }
      },
      // 上一张
      clickPrev() {
        console.log(this.galleryTop.activeIndex)
        if (this.galleryTop.activeIndex == 0) {
          this.galleryTop.slideTo(this.galleryTop.slides.length - 1, 1000);
          return
        }
        this.galleryTop.slidePrev()
      },
      // 下一张
      clickNext() {
        if (this.galleryTop.activeIndex == this.galleryTop.slides.length - 1) {
          this.galleryTop.slideTo(0, 1000);
          return
        }
        this.galleryTop.slideNext()
      },
      updateNavPosition() {
        this.$refs.myThumb.getElementsByClassName('swiper-slide active')[0].classList.remove('active')
        this.$refs.myThumb.getElementsByClassName('swiper-slide')[this.galleryTop.activeIndex].classList.add('active')
        let activeNav = this.$refs.myThumb.getElementsByClassName('swiper-slide active')[0]
        let arr = this.$refs.myThumb.getElementsByClassName('swiper-slide')
        let activeNavIndex = 0 // 缩略图点击的index值
        for(let i = 0; i < arr.length; i++) {
          if(arr[i].className.includes('swiper-slide active')) {
            activeNavIndex = i
            break
          }
        }
        if (!activeNav.classList.contains('swiper-slide-visible')) {
          if (activeNavIndex > this.galleryThumbs.activeIndex) {
            // var thumbsPerNav = Math.floor(this.galleryThumbs.width / activeNav.offsetWidth) - 1
            // 保证后面有一张图可以显示出来
            // 第7(index为6)个的时候应该滑到第一个（5为缩略图显示个数-2）
            // this.galleryThumbs.slideTo(activeNavIndex - 5)  // 轮播图有6个


            this.galleryThumbs.slideTo(activeNavIndex - 2) // 有3个
          } else {
            this.galleryThumbs.slideTo(activeNavIndex)
          }
        }
      }
    },
    mounted() {
      window.addEventListener('resize', this.reDraw)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.reDraw)
    }
  }
</script>

<style lang="scss" scoped>
.cmp-swiper-wrap {
  position: relative;
  // width: 800px;
  // height: 300px;
  .swiper-container {
    width: 100%;
    height: 460px;
    margin-left: auto;
    margin-right: auto;
  }
  .swiper-slide {
    width: 100%;
    // height: 100px;
    position: relative;
    background-size: cover;
    background-position: center;
  }
  .gallery-wrap {
    // display: flex;
    .gallery-top {
      position: relative;
      // flex: 1;
      // width: 916px;
      width: 100%;
      // width: 400px;
      // height: 400px;
      height: 540px;
      // width: 1000px;
      // height: 700px;
      .swiper-slide {
        width: 100%;
        height: 100%;
        background: #EEEEEE;
        // background: url(~@images/swiper-bg.png) no-repeat center center;
        // background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        .pic_bg {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          filter: blur(50px);
          /* transform: scale(2); */
          background-position: center center;
          background-size: 200% 200%;
        }
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
    }
    .icon-3d-box {
      position: absolute;
      right: 40px;
      top: 40px;
      z-index: 3;
      width: 80px;
      height: 80px;
      border-radius: 100%;
      background: rgba($color: #000000, $alpha: 0.6);
      display: flex;
      align-items: center;
      justify-content: center;
      .icon-3d {
        display: inline-block;
        width: 49px;
        height: 56px;
        background: url(~@images/icon-3d.png) no-repeat center center;
        background-size: 100% 100%;
      }
    }
    
    .box-like {
      display: flex;
      align-items: center;
      .icon-like {
        margin-right: 5px;
        width: 16px;
        height: 15px;
        background: url(~@images/icon_like.png) no-repeat center center;
        background-size: 100% 100%;
        &.active {
          background: url(~@images/icon_like_active.png) no-repeat center center;
          background-size: 100% 100%;
        } 
      }
    }
  }
  .gallery-thumbs {
    height: 187px;
    padding: 10px 2px;
    // width: 1600px;
    width: 600px;
    margin: 0;
    margin-left: 25px;
    // margin: 0 auto;
    box-sizing: border-box;
  }
  .gallery-thumbs .swiper-slide {
    // width: 188px;
    width: 189px;
    // width: 160px;
    // width: 25%;
    height: 100%;
    // opacity: 0.4;
    border: solid 3px transparent;
    margin-right: 6px;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      background: #e5e5e5;
    }
  }
  // .gallery-thumbs .swiper-slide-active {
  .gallery-thumbs .active {
    opacity: 1;
    border: solid 3px $primary;
    // border: solid 3px #d6a884;
    box-shadow: 0px 2px 3px 0px rgba(176,172,167,0.90); 
  }
  .thumbs-wrap {
    width: 650px;
    position: relative;
    z-index: 3;
    margin: 40px auto;
    // margin-top: -187px;
    .swiper-button-prev {
      width: 48px;
      height: 48px;
      position: absolute;
      left: 0;
      top: 50%;
      background: url(~@images/btn-prev.png) no-repeat center center;
      background-size: 100%;
    }
    .swiper-button-next {
      width: 48px;
      height: 48px;
      position: absolute;
      right: 0;
      top: 50%;
      background: url(~@images/btn-next.png) no-repeat center center;
      background-size: 100%;
    }
  }


  .pic-info {
    // padding-top: 30px;
    // padding-left: 20px;
    flex: initial;
    box-sizing: border-box;
    position: relative;
    flex: 1;
    font-size: 24px;
    color: #000000;
    background: #F6F6F6;
    .g-border {
      // padding-top:60px;
      padding: 0;
    }
    .collect-title {
      // font-size: 44px;
      color: #000000;
    }
    .des-box {
      margin-top: 40px;
      p {
        margin-bottom: 20px;
        label {
          opacity: 0.7;
        }
      }
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      box-sizing: border-box;
      width: 100%;
      position: absolute;
      left: 0;
      bottom: 30px;
      cursor: pointer;
      
    }
  }
}
</style>